import errors from "./errors"
import fields from "./fields"

export default { ...errors, ...fields }
